import { getNumberRange } from "../utils";

export type Month = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
export interface MonthInfo {
  name: string;
  short: string;
  number: number;
  days: number;
}
export const months: MonthInfo[] = [
  {
    name: "January",
    short: "Jan",
    number: 1,
    days: 31,
  },
  {
    name: "February",
    short: "Feb",
    number: 2,
    days: 28,
  },
  {
    name: "March",
    short: "Mar",
    number: 3,
    days: 31,
  },
  {
    name: "April",
    short: "Apr",
    number: 4,
    days: 30,
  },
  {
    name: "May",
    short: "May",
    number: 5,
    days: 31,
  },
  {
    name: "June",
    short: "Jun",
    number: 6,
    days: 30,
  },
  {
    name: "July",
    short: "Jul",
    number: 7,
    days: 31,
  },
  {
    name: "August",
    short: "Aug",
    number: 8,
    days: 31,
  },
  {
    name: "September",
    short: "Sep",
    number: 9,
    days: 30,
  },
  {
    name: "October",
    short: "Oct",
    number: 10,
    days: 31,
  },
  {
    name: "November",
    short: "Nov",
    number: 11,
    days: 30,
  },
  {
    name: "December",
    short: "Dec",
    number: 12,
    days: 31,
  },
];

/**
 * An array of all the possible day numbers in a month (1 - 31)
 *
 *
 */
export const allDays = getNumberRange(1, 31);

/**
 * all month numbers in a year (1 - 12);
 */
export const allMonths = getNumberRange(1, 12);

const days31 = getNumberRange(1, 31);
const days30 = getNumberRange(1, 30);
const days29 = getNumberRange(1, 29);

/**
 * All the days in each month.
 * Does not account for feb leap years.
 *
 * For feb we return 29 days as default instead of 28 because when we may
 * not know the year yet. eg when entering date of birth
 *  dd / mm / yyyy.
 * We will eventually know the month and year but not at the start so 29th must be
 * valid
 */
export const daysInMonth = {
  1: days31,
  2: days29,
  3: days31,
  4: days30,
  5: days31,
  6: days30,
  7: days31,
  8: days31,
  9: days30,
  10: days31,
  11: days30,
  12: days31,
};

export function toMonthShortName(month: number | undefined) {
  if (!month) return "";
  return months[month - 1]?.short || "";
}
